import axios from 'axios';
import globals from "../config/appconfig";

export default class MediciService {

    // static urlMedici = "http://localhost:8082/api/v1/medici/ricercamedico" //mockup per run locale

    static urlGetMedici = globals["app-url-backend-anagrafica"] + "/medici/ricercamedico" //mockup per run locale
    static urlPostMedico = globals["app-url-backend-anagrafica"] + "/medici/inseriscimedico"
    static urlPutMedico = globals["app-url-backend-anagrafica"] + "/medici/aggiornamedico/{idMedico}"
    static urlGetMedicoById = globals["app-url-backend-anagrafica"] + "/medici/ricercamedico/{idMedico}"

    static getMedici(params) {
        let querystring = "?";

        Object.keys(params).forEach(function (key) {
            querystring += key + "=" + params[key] + "&";
        });
        querystring = querystring.substring(0, querystring.length - 1);

        return axios.get(this.urlGetMedici + querystring)
    }

    static getMedicoById(idMedico) {
        return axios.get(this.urlGetMedicoById.replace("{idMedico}", idMedico))
    }

    static postInserimentoMedico(jsonInsertMedico) {
        return axios.post(this.urlPostMedico, jsonInsertMedico)
    }

    static putInserimentoMedico(idMedico, jsonPutMedico) {

        return axios.put(this.urlPutMedico.replace("{idMedico}", idMedico), jsonPutMedico)

    }

}
